import styled from 'styled-components'

export const StyledSpinner = styled.div`
  position: relative;
`
